import axios from "axios"

import { API_URL } from "../../config/appConfig"

export const ORG_USER_BASE_URL = `${API_URL}/api/OrganizationUser`

export const getAllUsers = () => {
  return axios.get(ORG_USER_BASE_URL)
}

export const getAllUsersPaginated = (payload: any, params: any, headers: any) => {
  return axios.post(`${ORG_USER_BASE_URL}/userList`, payload, { params, headers })
}

export const getOrganizationUsersByOrgId = (organizationPk: number, headers: any) => {
  return axios.get(`${ORG_USER_BASE_URL}/${organizationPk}`, { headers })
}

export const getUserInfo = (username: number) => {
  return axios.get(`${ORG_USER_BASE_URL}/nwsfinfo/${username}`)
}